import ClinicalConcernsLog from './ClinicalConcernsLog';

export default ClinicalConcernsLog;
